import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBBadge  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip, Divider   } from 'antd';
import Swal from 'sweetalert2/dist/sweetalert2.js'
import { ThunderboltFilled } from '@ant-design/icons';

export default class Modalroom extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,

   CRHR:"",
   idroom:'',
   nameroom:'',
  

}


//this.getExpert = this.getExpert.bind(this);
}


 componentDidMount() {
      const { idroom } = this.props.idroom
    //  console.log(this.props.id_send);
      this.setState({ idroom:this.props.idroom})

      setTimeout(() => {
        //ภายใน
         Axios.get('https://git.kpru.ac.th/FrontEnd_Tabian/load/getroomshow1/'+this.props.idroom)
        .then(res => {
          console.log(res);
        //  this.setState({ bankname: res.data, loading: false })
       //  this.setState({ showteachingschedule: res.data})
 
          if (res.data.length !== 0) {
            const nameroom = res.data[0].name_room;
          //  const prenm = res.data[0].prenm;
            this.setState({ nameroom });
          //  this.setState({ prenm });
          }
          
        }) 
      }, 0);
  
  }



    render() {
    
        
        return (
            <>
          
         {this.state.nameroom}
           

          </>
          
        )
    }
}
